<template>
  <div class="td-money-component">
    <template v-if="order.status === 'PAY_CONFIRMED'">
      <p>实付金额</p>
      <span class="price">{{priceUnit}}{{order.orderRealPayPrice}}</span>
    </template>
    <template v-else>
      <p>应付金额</p>
      <span class="price">{{priceUnit}}{{order.realPayPrice}}</span>
    </template>
  </div>
</template>

<script>
import { CURRENCY_LABEL } from '@/util/const'

export default {
  props: {
    order: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  computed: {
    priceUnit() {
      return CURRENCY_LABEL[this.order.currency]
    }
  }
}
</script>
